<template>
  <form @submit.prevent="handleSubmit" class="formContainer">

    <!-- Profile Image Section -->
    <div class="imageSection mb-3"> 
      <label class="inputLabel">Каталоги</label>

      <!-- Image Cropper -->
      <Cropper 
        v-if="isEditingImage" 
        class="cropper" 
        :src="currentimage" 
        @change="onCropChange"
        :stencil-props="{ aspectRatio: 700 / 350 }"   
      />

      <img 
        v-else-if="Data.image" 
        :src="Data.image" 
        class="profileImage" 
        alt="Каталоги" 
      />

      <!-- Upload Placeholder -->
      <div v-else class="uploadPlaceholder">
        <input 
          type="file" 
          @change="handleImageUpload" 
          accept="image/*" 
          class="fileInput" 
          ref="fileInput" 
          style="display: none;"
        />
        <button type="button" @click="triggerFileInput" class="uploadButton">
          Зураг оруулах
        </button>
      </div>

      <!-- Remove or Save/Cancel Buttons -->
      <div v-if="Data.image && !isEditingImage">
        <button type="button" @click="removeImage" class="btn mb-3 mb-sm-0 btn-icon btn-white">
          Зургийг устгах
        </button>
      </div>

      <div v-if="isEditingImage" class="imageControls">
        <button type="button" @click="saveImage" class="btn mb-3 mb-sm-0 btn-icon btn-white">
          Хадгалах
        </button>
        <button type="button" @click="cancelImageEdit" class="btn mb-3 mb-sm-0 btn-icon btn-white">
          Цуцлах
        </button>
      </div>
    </div>

    <!-- Хувийн мэдээлэл -->
    <div class="infoSection">
      <input 
        v-model="Data.link" 
        class="input" 
        type="text" 
        placeholder="Холбоос" 
        required 
      />
      <div class="toggle">
        <input 
          type="checkbox" 
          v-model="Data.active" 
          :id="'status-toggle'" 
          style="margin-bottom: 6px;"
        />
        <label :for="'status-toggle'">
          <!-- Харуулах Харуулахгүй -->
          {{ Data.active ? "Харуулах" : "Харуулахгүй" }}
        </label>
      </div>
    </div>

    <!-- Илгээх товч -->
    <div class="buttonContainer">
      <button type="submit" class="submitButton">
        {{ catalog_id ? "Өөрчлөлтийг хадгалах" : "Каталоги  үүсгэх" }}
      </button>
    </div>
  </form>
</template>

<script>
import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'
import axios from 'axios'

export default {
  name: 'CatalogeList',
  components: { Cropper },
  data() {
    return {
      Data: {
        id: null,  
        link: '',
        active: true,
        image: '',
      },
      isEditingImage: false,
      currentimage: '',
      croppedImageData: null
    }
  },
  computed: {
    catalog_id() {
      return this.$route.params.id ? parseInt(this.$route.params.id) : null;
    },
  },
  created() {
    this.fetchData()
  },

  methods: {
    // ✅ Fetch existing data
    fetchData() {
      if (this.catalog_id !== 0) {
        axios.get(`/catalog/${this.catalog_id}`)
          .then(response => {
            this.Data = { ...response.data }
          })
          .catch(error => {
            console.error('Мэдээллийг татаж чадсангүй:', error)
          })
      }
    },

    // ✅ Handle image upload
    triggerFileInput() {
      this.$refs.fileInput.click()
    },

    handleImageUpload(event) {
      const file = event.target.files[0]
      if (file) {
        const reader = new FileReader()
        reader.onload = (e) => {
          this.currentimage = e.target.result
          this.isEditingImage = true
        }
        reader.readAsDataURL(file)
      }
    },

    // ✅ Handle image cropping
    onCropChange({ canvas }) {
      const targetWidth = 1400;
      const targetHeight = 700;

      const offscreenCanvas = document.createElement("canvas");
      offscreenCanvas.width = targetWidth;
      offscreenCanvas.height = targetHeight;

      const ctx = offscreenCanvas.getContext("2d");
      ctx.drawImage(canvas, 0, 0, targetWidth, targetHeight);

      // ✅ Save cropped image
      this.Data.image = offscreenCanvas.toDataURL("image/jpeg", 0.7);
    },

    saveImage() {
      this.isEditingImage = false;
      this.$alert.showAlert('Зураг амжилттай шинэчлэгдлээ', 'success');
    },

    cancelImageEdit() {
      this.isEditingImage = false;
    },

    removeImage() {
      this.Data.image = '';
      this.$alert.showAlert('Зураг устлаа', 'success');
    },

    // ✅ Handle create or update based on id
    handleSubmit() {
      console.log('Submitting Data:', this.Data);

      // ✅ Validate link format
      const linkPattern = /^(https?:\/\/)/;
      if (this.Data.link && !linkPattern.test(this.Data.link)) {
        this.Data.link = `http://${this.Data.link}`;
      }

      if (this.Data.id) {
        // ✅ Update existing data
        axios.put(`/catalog/${this.Data.id}`, this.Data)
          .then(() => this.$alert.showAlert('Амжилттай шинэчлэгдлээ', 'success'))
          .catch((error) => this.$alert.showAlert(`Шинэчлэхэд алдаа гарлаа: ${error.message}`, 'error'));
      } else {
        // ✅ Create new data
        axios.post('/catalog', this.Data)
          .then(() => this.$alert.showAlert('Амжилттай үүслээ', 'success'))
          .catch((error) => this.$alert.showAlert(`Үүсгэхэд алдаа гарлаа: ${error.message}`, 'error'));
      }
    }
  }
}
</script>

<style>
/* ✅ Use consistent styling, including buttons, inputs, and layout */

.formContainer {
  display: flex;
  flex-direction: column;
  align-items: left;
  width: 100%;
  background-color: white;
  padding: 32px;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}
.imageSection {
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;

}

.input {
  width: 100%;
  padding: 14px;
  margin-bottom: 16px;
  border: 2px solid #CBD5E1;
  border-radius: 8px;
  font-size: 16px;
}

.buttonContainer {
  width: 100%;
  display: flex;
  justify-content: center;
}

.submitButton {
  background-color: #2D5A87;
  color: white;
  padding: 14px 32px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
}

.submitButton:hover {
  background-color: #1F4369;
}

.toggle {
  display: flex;
  align-items: center;
}

.toggle input {
  margin-right: 8px;
}

.profileImage {
  width: 700px;
  height: 350px;
  object-fit: cover;
}

.uploadPlaceholder {
  width: 700px;
  height: 350px;
  border: 2px dashed #CBD5E1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.uploadButton {
  background-color: #2D5A87;
  color: white;
  padding: 10px 20px;
  border-radius: 8px;
  cursor: pointer;
}
</style>
